import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="about-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="mb-5 mb-lg-0">
            <div className="about-content">
              <h2 className="section-title">Our Commitment to Excellence</h2>
              <div className="title-underline"></div>
              <p className="section-subtitle">
                With decades of experience in poultry Division, Animal Division,
                and aqua Division
              </p>
              <p>
                We provide innovative solutions that enhance production
                efficiency, promote animal welfare, and support sustainable
                farming practices. Our team of experts works closely with
                farmers to develop customized approaches that address their
                specific needs and challenges.
              </p>
              <ul className="feature-list">
                <li>
                  <span className="feature-icon">✓</span> Premium quality
                  products
                </li>
                <li>
                  <span className="feature-icon">✓</span> Environmentally
                  sustainable solutions
                </li>
                <li>
                  <span className="feature-icon">✓</span> Expert technical
                  support
                </li>
                <li>
                  <span className="feature-icon">✓</span> Research-backed
                  innovations
                </li>
              </ul>
              <Button variant="primary" className="mt-4 btn-custom">
                Learn More
              </Button>
            </div>
          </Col>
          {/* <Col lg={6}>
            <div className="about-image-container">
              <img
                src="./images/blob.jpeg"
                alt="Modern farming facilities"
                className="img-fluid masked-image"
              />
            </div>
          </Col> */}
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
